import React from 'react';
import ProjectsContext, { ProjectsStore } from './ProjectsContext';
import { FunctionsStore } from '../functions/FunctionsContext';
import CircularProgress from '@material-ui/core/CircularProgress';

import ProjectsList from './ProjectsList';
import ProjectFunctionsList from './ProjectFunctionsList';
import ProjectFunctionDetails from './ProjectFunctionDetails';
import GbuFunctionDetails from './GbuFunctionDetails';
import styled from 'styled-components';
import ProjectAddModal from './ProjectAddModal';
import EmptyStateMessage from '../common/EmptyStateMessage';
import ConfirmGBUApproversDialog from './ConfirmGBUApproversDialog';
import ProjectCustomNameDialog from './ProjectCustomNameDialog';
import ProjectsEmptyState from './ProjectsEmptyState';

const Container = styled.div`
    display:grid;
    // grid-template-columns: 240px 1px 240px 1px 1fr;
    grid-template-columns: 260px 1px 1fr;
`;

const ListContainer = styled.div`
   background-color:white;
   overflow-y:auto;
`;

const VerticalDivider2 = styled.div`
   background-color:lightgray;
`;

const DetailsContainer = styled.div`
   width:100%;
   overflow-y:scroll;
`;

const CircularProgressContainer = styled.div`
   width:100%;
   display : flex;
   align-items :center;
   justify-content:center;
`;

const ProjectsMain = props => {
    const renderContent = (context) =>
    { return (
        <>
        <ConfirmGBUApproversDialog/>
        {context.changeDisplayFunctionList && <ProjectCustomNameDialog context={context}/> }
        <Container style={{height:context.contentHeight}}>
            <ListContainer>
                {!context.changeDisplayFunctionList && <ProjectsList/>}
                {context.changeDisplayFunctionList && <ProjectFunctionsList/>}
            </ListContainer>
            <VerticalDivider2/>
            {context.reduxStore.updatingProjectDetails ?
                 <CircularProgressContainer style={{height:context.contentHeight}}><CircularProgress/></CircularProgressContainer>
                :
                <DetailsContainer id="project-details-container" style={{height:context.contentHeight}}>

                    {context.reduxStore.selectedFunctionDetails &&  context.reduxStore.selectedProjectOrGbu.isGbu && context.reduxStore.selectedFunctionDetails.id !== 0 && <GbuFunctionDetails/>}
                    {context.reduxStore.selectedFunctionDetails &&  context.reduxStore.selectedProjectOrGbu.isGbu === false && <ProjectFunctionDetails/>}
                    {context.reduxStore.selectedFunctionDetails === null && context.reduxStore.selectedProjectOrGbu === null
                        && <ProjectsEmptyState title="Select a project" subtitle="" showSVG="true"/>}                  
                </DetailsContainer>
            }
            <ProjectAddModal/>
        </Container>
    </> )
    }

    return (
        <FunctionsStore>
        <ProjectsStore>
            <ProjectsContext.Consumer>
                {context => {
                    if ( context.aboutCurrentUser) {
                        if(context.aboutCurrentUser.hasProjectPageAccess)
                        {
                            return renderContent(context);
                        }else {
                            return <EmptyStateMessage>
                                You do not have permission to view this page.
                            </EmptyStateMessage>
                        }
                    } else {
                        return null;
                    }
                }}
            </ProjectsContext.Consumer>
        </ProjectsStore>
        </FunctionsStore>
    )
}

export default ProjectsMain;